import { hdrm } from '@yola/ws-sdk';
import adjacentPositions from '../constants/adjacent-positions';
import getAllBlocksForTarget from './get-all-blocks-for-target';

const { AFTER_BEGIN, BEFORE_END } = adjacentPositions;

function getAllBlocksForInsertionPoint({ targetElementId, adjacentPosition, featureFlags }) {
  const targetElement =
    adjacentPosition === AFTER_BEGIN || adjacentPosition === BEFORE_END
      ? hdrm.accessors.getLiveElement(targetElementId)
      : hdrm.accessors.getParentLiveElement(targetElementId);

  return getAllBlocksForTarget({
    targetElement,
    featureFlags,
  });
}

export default getAllBlocksForInsertionPoint;
